document.addEventListener('DOMContentLoaded', function(){

  // sticky header
  const stickyHeader = document.querySelector('.fn-sticky-header');
  if (stickyHeader) {
    const headerHeight = stickyHeader.clientHeight;
    let startPos = 0;
    let winScrollTop = 0;
    let timeoutId;

    window.addEventListener('scroll', (element) => {
      winScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (winScrollTop >= startPos && winScrollTop >= headerHeight) {
        stickyHeader.classList.add('is-hidden');
      } else {
        stickyHeader.classList.remove('is-hidden');
      }
      startPos = winScrollTop;

      // remove class when stoped scroll
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        stickyHeader.classList.remove('is-hidden');
      }, 1000);
    });
  }

  // sliders
  const sliderDots = document.querySelectorAll('.fn-swiper-container-dots');
  const sliderArrowDots = document.querySelectorAll('.fn-swiper-container-arrow-dots');
  const sliderCarousel = document.querySelectorAll('.fn-swiper-container-calousel');
  const sliderCarouselDots = document.querySelectorAll('.fn-swiper-container-calousel-dots');

  const variables = [];
  const setSlider = (slideName, sliders, args, calousel = false) => {
    sliders.forEach((slideWrap, index, array) => {
      const slideAll = slideWrap.querySelectorAll('.swiper-slide'); 
      const newSlider = slideName + index;
      if (slideAll.length > 1) {
        if (calousel) {
          const slideWidth = slideAll[0].offsetWidth;
          const windowWidth = window.innerWidth;
          if (slideWidth * slideAll.length > windowWidth) {
            variables[newSlider] = new Swiper(slideWrap, args);
          } else {
            slideAll.forEach((item) => {
              const slideImage = item.querySelector('.swiper-lazy');
              if (slideImage) {
                const src = slideImage.dataset.src;
                slideImage.setAttribute('src', src);
              }
            });
          }
        } else {
          variables[newSlider] = new Swiper(slideWrap, args);
        }
      }
    });
  }

  if (sliderDots.length > 0) {
    const argsDots = {
      speed: 1000,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    };
    setSlider('sliderDots', sliderDots, argsDots);
  }

  if (sliderArrowDots.length > 0) {
    const argsArrowDots = {
      speed: 1000,
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    };
    setSlider('sliderArrowDots', sliderArrowDots, argsArrowDots);
  }

  if (sliderCarousel.length > 0) {
    const argsCalousel = {
      speed: 1000,
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };
    setSlider('sliderCarousel', sliderCarousel, argsCalousel, false);
  }

  if (sliderCarouselDots.length > 0) {
    const argsCalousel = {
      speed: 1000,
      loop: true,
      slidesPerView: 'auto',
      centeredSlides: true,
      grabCursor: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
    };
    setSlider('sliderCarouselDots', sliderCarouselDots, argsCalousel, true);
  }

  // search box and header menu for mobile
  const searchButton = document.querySelector('.fn-search-button');
  const searchWrap = document.querySelector('.fn-search-wrap');
  const menuButton = document.querySelector('.fn-menu-button');
  const menuWrap = document.querySelector('.fn-header-menu-wrap');
  const menuBg = document.querySelector('.fn-header-nav-bg');

  const stopScrollIos = () => {
    if (document.body.classList.contains('is-no-scroll')) {
      document.body.addEventListener('touchmove', (e) => {
        e.preventDefault();
      });
    }
  }

  if (searchButton && searchWrap) {
    searchButton.addEventListener('click', () => {
      searchWrap.classList.toggle('is-active');
      if (menuWrap.classList.contains('is-active') && document.body.classList.contains('is-no-scroll')) {
        menuWrap.classList.remove('is-active');
        document.body.classList.remove('is-no-scroll');
      }
    });
  }

  if (menuButton) {
    const clickEventMenu = () => {
      menuWrap.classList.toggle('is-active');
      document.body.classList.toggle('is-no-scroll');
      if (searchWrap.classList.contains('is-active')) {
        searchWrap.classList.remove('is-active');
      }
      if (document.body.classList.contains('is-no-scroll')) {
        document.body.addEventListener('touchmove', (e) => {
          e.preventDefault();
        });
      }
    }

    menuButton.addEventListener('click', () => {
      clickEventMenu();
    });
    menuBg.addEventListener('click', () => {
      clickEventMenu();
    });
  }

}, false);
